import { AfterViewInit, ChangeDetectionStrategy, Component, ContentChildren, QueryList, ViewChildren } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";
import { EntityDirective } from "./entity.directive";

interface GroupedEntities {
    [key: string]: EntityDirective[];
}

export interface RegisteredEntitiesComponentState {
    selectedEntity: EntityDirective | undefined;
    entities: GroupedEntities | undefined;
}

@Component({
    selector: "dtm-main-page-lib-kpo-registered-entities",
    templateUrl: "./registered-entities.component.html",
    styleUrls: ["registered-entities.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class RegisteredEntitiesComponent implements AfterViewInit {
    @ViewChildren(EntityDirective) protected innerContent!: QueryList<EntityDirective>;
    @ContentChildren(EntityDirective) protected projectedContent!: QueryList<EntityDirective>;

    protected readonly selectedEntity$ = this.localStore.selectByKey("selectedEntity");
    protected readonly groupedEntities$ = this.localStore.selectByKey("entities");

    constructor(private readonly localStore: LocalComponentStore<RegisteredEntitiesComponentState>) {
        localStore.setState({ selectedEntity: undefined, entities: undefined });
    }

    public ngAfterViewInit(): void {
        const content = [...this.innerContent.toArray(), ...this.projectedContent.toArray()];

        if (!content.length) {
            return;
        }

        this.localStore.patchState({ entities: this.groupEntities(content), selectedEntity: content[0] });
    }

    protected openDetails(event: Event, entity: EntityDirective): void {
        event.preventDefault();
        this.localStore.patchState({ selectedEntity: entity });
    }

    private groupEntities(entities: EntityDirective[]): GroupedEntities {
        return entities.reduce((results: GroupedEntities, entity) => {
            if (!results[entity.voivodeship]) {
                results[entity.voivodeship] = [];
            }

            results[entity.voivodeship].push(entity);

            return results;
        }, {});
    }
}
